<template>
  <div>
    <el-form ref="chartForm" :model="chart" label-width="110px" class="demo-dynamic">
      <!-- 图表宽度 -->
      <el-form-item label="图表宽度" class="w-300">
        <el-input v-model="chart.style.width" placeholder="图表宽度"></el-input>
      </el-form-item>
      <!-- 图表高度 -->
      <el-form-item label="图表高度" class="w-300">
        <el-input v-model="chart.style.height" placeholder="图表高度"></el-input>
      </el-form-item>
      <!-- 横坐标 -->
      <el-form-item label="X坐标轴名" class="w-300">
        <el-input v-model="chart.tableData[0].name" placeholder="X坐标轴名"></el-input>
      </el-form-item>
      <el-form-item label="柱宽" class="w-300">
        <el-input v-model="chart.tableData[0].barWidth" placeholder="柱宽"></el-input>
      </el-form-item>
      <el-form-item label="X坐标字段">
        <el-select v-model="chart.tableData[0].x_axis" placeholder="请选择" @change="xaxisChange">
          <el-option
            v-for="item in chart.fields"
            :label="item.field"
            :value="item.field">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 系列 -->
      <el-form-item label="系列">
        <el-select v-model="chart.tableData[2].series" placeholder="请选择">
          <el-option
            v-for="item in chart.fields"
            :label="item.field"
            :value="item.field">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 纵坐标 -->
      <el-form-item label="y坐标轴名" class="w-300">
        <el-input v-model="chart.tableData[1].name" placeholder="y坐标轴名"></el-input>
      </el-form-item>
      <el-form-item label="计算方式" class="w-300">
        <el-radio-group v-model="chart.tableData[1].calculate_type" @change="calculateChange">
          <el-radio class="radio" :label="10">计量</el-radio>
          <el-radio class="radio" :label="20">计数</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="y坐标字段">
        <el-select v-model="chart.tableData[1].y_axis" :disabled="disableYField" placeholder="请选择">
          <el-option
            v-for="item in chart.fields"
            :label="item.field"
            :value="item.field">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 时间粒度 -->
      <el-form-item v-show="showTimeSelect" label="时间粒度">
        <el-select v-model="chart.time_unit" placeholder="请选择">
          <el-option
            v-for="item in timeOptions"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  export default {
    name: 'chartConfig',
    props: {
      chart: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        timeOptions: [{
          label: '秒',
          value: 10
        }, {
          label: '分',
          value: 20
        }, {
          label: '时',
          value: 30
        }, {
          label: '天',
          value: 40
        }, {
          label: '星期',
          value: 50
        }, {
          label: '月',
          value: 60
        }, {
          label: '季度',
          value: 70
        }, {
          label: '年',
          value: 80
        }]
      }
    },
    created() {
    },
    methods: {
      xaxisChange(item) {
        _(this.chart.fields).forEach((res) => {
          if (res.field == item) {
            let type = res.field_type
            this.chart.tableData[0].x_axis_type = type
            if (type != 70 || type != 80 || type != 90) {
              this.chart.time_unit = null
            }
          }
        })
      },
      calculateChange(item) {
        if (item == 10) {
          this.chart.tableData[1].y_axis = ''
        }
      }
    },
    computed: {
      showTimeSelect() {
        let type = this.chart.tableData[0].x_axis_type
        return type == 70 || type == 80 || type == 90
      },
      disableYField() {
        return this.chart.tableData[1].calculate_type == 10
      }
    }
  }
</script>


// WEBPACK FOOTER //
// barChartConfig.vue?24e9aa7f